module.exports = __webpack_public_path__ + "static/pr-op-real-updates-f6c3eae2ea452425e0f65a61eaa80c89.png";